var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      cursor: "pointer"
    },
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".add-marker-cls-1{fill:url(#add-marker-linear-gradient-);}.add-marker-cls-2{fill:#e31f26;}.add-marker-cls-3{fill:#fffcd5;}.add-marker-cls-4{fill:url(#add-marker-linear-gradient--2);}")), /*#__PURE__*/React.createElement("linearGradient", {
    style: {
      cursor: "pointer"
    },
    id: "add-marker-linear-gradient-",
    x1: 100,
    y1: 187.04,
    x2: 100,
    y2: 17.5,
    gradientTransform: "translate(101.61 -40.76) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      cursor: "pointer"
    },
    offset: 0.31,
    stopColor: "#f5da52"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      cursor: "pointer"
    },
    offset: 1,
    stopColor: "#fff799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    style: {
      cursor: "pointer"
    },
    id: "add-marker-linear-gradient--2",
    x1: 100,
    y1: 148.46,
    x2: 100,
    y2: 53.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      cursor: "pointer"
    },
    offset: 0,
    stopColor: "#e31f26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      cursor: "pointer"
    },
    stopColor: "#fff450"
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      cursor: "pointer"
    },
    className: "add-marker-cls-1",
    cx: 100,
    cy: 102.27,
    r: 84.77,
    transform: "translate(-43.03 100.67) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      cursor: "pointer"
    },
    className: "add-marker-cls-2",
    d: "M100,17.5a84.77,84.77,0,1,1-84.77,84.77A84.77,84.77,0,0,1,100,17.5m0-5.23A90,90,0,0,0,65,185.2,90,90,0,0,0,135,19.35a89.33,89.33,0,0,0-35-7.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      cursor: "pointer"
    },
    className: "add-marker-cls-3",
    d: "M100,23.29a84.75,84.75,0,0,1,84.7,81.87c0-1,.07-1.92.07-2.89a84.77,84.77,0,0,0-169.54,0c0,1,0,1.93.07,2.89A84.75,84.75,0,0,1,100,23.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      cursor: "pointer"
    },
    className: "add-marker-cls-3",
    cx: 100,
    cy: 102.27,
    r: 69.87
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      cursor: "pointer"
    },
    className: "add-marker-cls-4",
    d: "M100,53.71A35.57,35.57,0,0,0,64.47,89.24,35.22,35.22,0,0,0,71.18,110l.93,1.31,25.52,36a3,3,0,0,0,4.74,0l25.2-35.58,1.25-1.73A35.49,35.49,0,0,0,100,53.71Zm0,47.37a11.84,11.84,0,1,1,11.84-11.84A11.85,11.85,0,0,1,100,101.08Z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMarker);
export default __webpack_public_path__ + "static/media/addMarker.7ffbb9be.svg";
export { ForwardRef as ReactComponent };